import { render, staticRenderFns } from "./MergeCustomer.vue?vue&type=template&id=0e448718&scoped=true"
import script from "./MergeCustomer.vue?vue&type=script&lang=js"
export * from "./MergeCustomer.vue?vue&type=script&lang=js"
import style0 from "./MergeCustomer.vue?vue&type=style&index=0&id=0e448718&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e448718",
  null
  
)

export default component.exports